import { Badge, Button, Card, Checkbox, Divider, Drawer, InputNumber, Rate } from 'antd';
import React, { useState, useEffect } from 'react';
import { FiShoppingCart } from 'react-icons/fi';
import { TfiMore } from 'react-icons/tfi';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './index.css';
import Header from '../../components/IT-tracking/Header';
import { getAllProducts } from './utils';
import { useSearchParams } from 'react-router-dom';
import { getApi } from '../../services/api';
import { Modal } from 'antd';

// const products = [
// 	{
// 		id: 1,
// 		name: 'Dell Latitude 3420',
// 		price: '₹39,999.00',
// 		originalPrice: '₹71,499.00',
// 		rating: 4,
// 		badge: '-50%',
// 		image: 'https://5.imimg.com/data5/GM/GI/MY-14628326/new-xps-13-laptop-500x500.png', // Replace with actual image URL
// 	},
// 	{
// 		id: 2,
// 		name: 'Dell Latitude 3420',
// 		price: '₹39,999.00',
// 		originalPrice: '₹71,499.00',
// 		rating: 4,
// 		badge: '-50%',
// 		image: 'https://5.imimg.com/data5/SELLER/Default/2022/8/HS/UH/QL/156789997/91wgl3ibnil-sl1500--500x500.jpg', // Replace with actual image URL
// 	},
// 	{
// 		id: 3,
// 		name: 'Dell Latitude 3420',
// 		price: '₹39,999.00',
// 		originalPrice: '₹71,499.00',
// 		rating: 4,
// 		badge: '-50%',
// 		image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ73JyASaTKxkRYYoeMpTo4lsq9aA2agXwI8g&s', // Replace with actual image URL
// 	},
// ];

const products = getAllProducts();

console.log(products.length, 'products.length');

const { Group: CheckboxGroup } = Checkbox;

const data = {
	// "Product Line": [
	//     { "name": "Latitude", "count": 6 },
	//     { "name": "XPS", "count": 5 },
	//     { "name": "Inspiron", "count": 11 },
	//     { "name": "Alienware", "count": 3 },
	//     { "name": "G-Series", "count": 3 },
	//     { "name": "Vostro", "count": 4 }
	// ],
	'PC Screen Size': [
		{ name: '45.72 cm (18 inch)', count: 1 },
		{ name: '40.60 cm (16 inch)', count: 7 },
		{ name: '38.10 cm (15 inch)', count: 8 },
		{ name: '35.56 cm (14 inch)', count: 10 },
		{ name: '33.02 cm (13 inch)', count: 6 },
	],
	'Form Factor': [
		{ name: '2-in-1 Or Detachable', count: 1 },
		{ name: 'Ultralight', count: 1 },
	],
	Processor: [
		{ name: 'All Intel Processors', count: 27 },
		{ name: 'Intel Core Ultra 9', count: 3 },
		{ name: 'Intel Core Ultra 7', count: 11 },
		{ name: 'Intel Core Ultra 5', count: 4 },
		{ name: 'Intel Core 7', count: 4 },
		{ name: 'Intel Core 5', count: 2 },
		{ name: 'Intel Core i9', count: 3 },
		{ name: 'Intel Core i7', count: 4 },
		{ name: 'Intel Core i5', count: 11 },
		{ name: 'Intel Core i3', count: 6 },
		{ name: 'All AMD Processors', count: 2 },
		{ name: 'AMD Ryzen 7', count: 1 },
		{ name: 'AMD Ryzen 5', count: 2 },
		{ name: 'AMD Ryzen 3', count: 1 },
		{ name: 'Snapdragon X Elite', count: 1 },
		{ name: 'Snapdragon X Plus', count: 2 },
	],
	// "Processor Generation": [
	//     { "name": "14th Gen Intel Core", "count": 1 },
	//     { "name": "13th Gen Intel Core", "count": 11 },
	//     { "name": "12th Gen Intel Core", "count": 2 },
	//     { "name": "AMD Ryzen 7000 Series", "count": 2 }
	// ],
	// "Processor Platform": [
	//     { "name": "Intel Evo", "count": 6 },
	//     { "name": "Intel vPro", "count": 3 }
	// ],
	// "Operating System": [
	//     { "name": "Windows 11 Pro", "count": 6 },
	//     { "name": "Windows 11 Home", "count": 26 }
	// ],
	// "Memory (RAM)": [
	//     { "name": "64 GB", "count": 1 },
	//     { "name": "32 GB", "count": 9 },
	//     { "name": "16 GB", "count": 24 },
	//     { "name": "8 GB", "count": 9 }
	// ],
	// "Graphics": [
	//     { "name": "All Intel Graphics", "count": 21 },
	//     { "name": "All NVIDIA Graphics", "count": 11 },
	//     { "name": "All AMD Graphics", "count": 1 },
	//     { "name": "AMD Radeon", "count": 1 },
	//     { "name": "Intel Arc", "count": 5 },
	//     { "name": "Intel Graphics", "count": 10 },
	//     { "name": "Intel Iris Xe", "count": 9 },
	//     { "name": "Intel UHD", "count": 10 },
	//     { "name": "NVIDIA GeForce MX550", "count": 2 },
	//     { "name": "NVIDIA GeForce MX570", "count": 1 },
	//     { "name": "NVIDIA GeForce RTX 3050", "count": 2 },
	//     { "name": "NVIDIA GeForce RTX 4050", "count": 3 },
	//     { "name": "NVIDIA GeForce RTX 4060", "count": 5 },
	//     { "name": "NVIDIA GeForce RTX 4070", "count": 2 },
	//     { "name": "NVIDIA GeForce RTX 4080", "count": 2 },
	//     { "name": "NVIDIA GeForce RTX 4090", "count": 2 },
	//     { "name": "Qualcomm Adreno GPU", "count": 3 }
	// ],
	// "Storage Size": [
	//     { "name": "1 TB", "count": 19 },
	//     { "name": "512 GB", "count": 23 }
	// ],
	// "PC Features": [
	//     { "name": "Backlit Keyboard", "count": 27 },
	//     { "name": "Fingerprint Reader", "count": 9 },
	//     { "name": "Lightweight", "count": 29 },
	//     { "name": "Numeric Keypad", "count": 10 },
	//     { "name": "Video Card", "count": 21 },
	//     { "name": "Wi-Fi 6", "count": 17 }
	// ],
	// "Touch Screen": [
	//     { "name": "Non-Touch Screen", "count": 26 },
	//     { "name": "Touch Screen", "count": 7 }
	// ],
	// "Aspect Ratio": [
	//     { "name": "16:10", "count": 20 },
	//     { "name": "16:9", "count": 12 }
	// ],
	// "Screen Resolution": [
	//     { "name": "4K UHD+", "count": 1 },
	//     { "name": "3.2K", "count": 1 },
	//     { "name": "3K", "count": 3 },
	//     { "name": "QHD+", "count": 7 },
	//     { "name": "2.2K", "count": 1 }
	// ],
	// "Colour Options": [
	//     { "name": "Black", "count": 4 },
	//     { "name": "Blue", "count": 7 },
	//     { "name": "Graphite", "count": 1 },
	//     { "name": "Grey", "count": 11 },
	//     { "name": "Metallic Nightshade", "count": 1 },
	//     { "name": "Platinum", "count": 4 },
	//     { "name": "Silver", "count": 8 }
	// ],
	// "Rating": [
	//     { "name": "4 stars & up", "count": 30 },
	//     { "name": "3 stars & up", "count": 32 },
	//     { "name": "2 stars & up", "count": 32 },
	//     { "name": "1 star & up", "count": 32 }
	// ]
};

const FilterDrawer = ({ filterModal, setFilterModal }) => {
	return (
		<Drawer
			title="Filters"
			open={filterModal}
			onClose={() => {
				setFilterModal(false);
			}}
		>
			<div className="filter-drawer">
				{Object.keys(data).map((heading) => (
					<div>
						<h4 className="filter-title">{heading}</h4>
						<CheckboxGroup
							options={data[heading].map((item) => ({
								label: `${item.name}`,
								value: item.name,
							}))}
							onChange={(checkedValues, y) => {
								console.log(checkedValues, y);
							}}
						/>
					</div>
				))}
			</div>
		</Drawer>
	);
};

const error = () => {
	Modal.error({
		title: 'Request Failed',
		afterClose: () => {},
		footer: null,
		onOk: () => {},
		content:
			'It looks like you have already filled the form or its expired right now. please connect with the respective HR team to generate new link.',
	});
};

const ShowProductSpec = ({ product }) => {
	const result = product.resourcePoints
		.map((item) => `${item.key} ${item.options[item.selectedPoint].value}`)
		.join(', ');
	console.log(result); // Output: "RAM 24GB, HDD 1024GB"
	return <div className="product-details">{result}</div>;
};

const InventoryProducts = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [filterModal, setFilterModal] = useState(false);
	const [cartVisible, setCartVisible] = useState(false);

	const [searchParams, setSearchParams] = useSearchParams();
	const token = searchParams.get('token');

	useEffect(() => {
		const getOnboarding = async function () {
			const resp = await getApi(`/assetze/open-api/onboarding?token=${token}`);
			if (resp.type === 'error') {
				error();
			}
		};
		getOnboarding();
	}, [token]);

	const handleAddToCart = (product) => {
		const productToAdd = {
			id: product.id,
			name: product.name,
			image: product.image,
			price: product.price,
			quantity: 1,
		};
	};

	return (
		<div>
			<Header />
			{/* <div style={{ display: 'flex', justifyContent: 'right', gap: '20px' }}>
				<Button
					onClick={() => {
						setFilterModal(true);
					}}
					className="more-btn"
					icon={<TfiMore />}
				></Button>
				<Button
					onClick={() => {
						setCartVisible(true);
					}}
				>
					Open Cart
				</Button>
			</div> */}
			<div style={{ display: 'flex' }}>
				{/* <FilterComponents /> */}
				<FilterDrawer filterModal={filterModal} setFilterModal={setFilterModal} />
				<div className="products-page2">
					{products.map((product, index) => {
						console.log(product.images, 'product.images');
						return (
							<Card
								onClick={() => {
									navigate(`/onboarding/device-selection/${product.id}?token=${token}`);
								}}
								bordered
								className="product-card"
								hoverable
								key={index}
								actions={[
									<div
										onClick={(e) => {
											e.stopPropagation();
											navigate(`/onboarding/device-selection/${product.id}?token=${token}`);
											// handleAddToCart(product);
										}}
									>
										<FiShoppingCart fontSize={25} />
									</div>,
								]}
								cover={
									<div className="product-image-wrapper">
										<Badge.Ribbon
											style={{ display: product.badge ? 'block' : 'none' }}
											text={product.badge}
											color={product.badge === 'Hot' ? 'red' : 'blue'}
										>
											<img alt={product.name} src={product.images[0]} className="product-image" />
										</Badge.Ribbon>
									</div>
								}
							>
								<div className="product-info">
									<h3 className="product-name">{product.name}</h3>
									<div className="product-details">{product.details}</div>
									<ShowProductSpec product={product} />
									<div className="product-details">{product.features}</div>
									<div className="product-pricing">
										<span className="product-price">
											{new Intl.NumberFormat('en-IN', {
												currency: 'INR',
												style: 'currency',
											}).format(product.price * 1)}
										</span>
										{product.originalPrice && (
											<span className="original-price">
												{new Intl.NumberFormat('en-IN', {
													currency: 'INR',
													style: 'currency',
												}).format(product.originalPrice * 1)}
											</span>
										)}
									</div>
									<div className="product-rating">
										<Rate disabled allowHalf value={product.rating} style={{ fontSize: '16px' }} />
										<span className="rating-text">{product.rating}.00 Rating</span>
									</div>
								</div>
							</Card>
						);
					})}
				</div>
			</div>
			<ShoppingCartDrawer setCartVisible={setCartVisible} cartVisible={cartVisible} />
		</div>
	);
};

export default InventoryProducts;

const ShoppingCartDrawer = ({ setCartVisible, cartVisible }) => {
	const dispatch = useDispatch();
	const [cartItems, setCartItems] = useState([
		{
			id: 1,
			name: 'Dell Latitude 3420',
			price: '₹39,999.00',
			quantity: 1,
			image: 'https://5.imimg.com/data5/GM/GI/MY-14628326/new-xps-13-laptop-500x500.png',
		},
		{
			id: 2,
			name: 'Dell Latitude 3420',
			price: '₹39,999.00',
			quantity: 2,
			image: 'https://5.imimg.com/data5/GM/GI/MY-14628326/new-xps-13-laptop-500x500.png',
		},
	]);

	const handleQuantityChange = (id, quantity) => {};

	const handleRemove = (id) => {};

	const calculateSubtotal = () => {
		return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
	};
	return (
		<div className="shopping-cart-container">
			{/* <Button
                type="primary"
                onClick={() => setCartVisible(true)}
                className="open-cart-btn"
            >
                Open Shopping Cart
            </Button> */}

			<Drawer
				title="Shopping Cart"
				placement="right"
				onClose={() => setCartVisible(false)}
				open={cartVisible}
				width={400}
				className="shopping-cart-drawer"
			>
				{cartItems.map((item) => (
					<div key={item.id} className="cart-item">
						<img src={item.image} alt={item.name} className="cart-item-image" />
						<div className="cart-item-details">
							<div className="cart-item-name">{item.name}</div>
							<div className="cart-item-price">Price: ${item.price}</div>
							<div className="cart-item-actions">
								<InputNumber
									min={1}
									value={item.quantity}
									onChange={(value) => handleQuantityChange(item.id, value)}
									className="quantity-input"
								/>
								<Button
									danger
									size="small"
									onClick={() => handleRemove(item.id)}
									className="remove-btn"
								>
									Remove
								</Button>
							</div>
						</div>
					</div>
				))}

				<Divider />

				<div className="subtotal-section">
					<span className="subtotal-text">Subtotal:</span>
					<span className="subtotal-amount">${calculateSubtotal()}</span>
				</div>

				<Button size="large" type="primary" block className="checkout-btn">
					Checkout
				</Button>
			</Drawer>
		</div>
	);
};
